<template>
    <div class="ancestor">
        <div class="theme-titles">
            <div class="theme-text">
                <img src="~assets/image/solution-img/sy04.gif" />
                <span class="theme-name">智能前置仓解决方案</span>
                <span class="boult">&gt;</span>
            </div>
        </div>
        <div class="sortware">
            <div class="title">智能前置仓</div>
            <h3>通过前置仓智能通道门部署的屏幕，每次进出仓数据可一目了然。</h3>
            <div class="imgs">
                <img src="~assets/image/solution-img/smartBeforeStore01.png" alt="智能出入库" />
            </div>
            <ul>
                <li>
                    <div><img src="~assets/image/solution-img/smart1.png" alt=""></div>
                    <p>人员识别：通过给授权人员发放芯片卡，用户进出前置仓自动识别授权用户，非授权用户进入通过语音和警报实现告警</p>
                </li>
                <li>
                    <div><img src="~assets/image/solution-img/smart2.png" alt=""></div>
                    <p>进出识别：智能判断人员，叉车、设备是进仓还是出仓行为</p>
                </li>
                <li>
                    <div><img src="~assets/image/solution-img/smart3.png" alt=""></div>
                    <p>数量识别：通过读取芯片自动识别进出托盘数量</p>
                </li>
                <li>
                    <div><img src="~assets/image/solution-img/smart4.png" alt=""></div>
                    <p>数量识别：通过读取芯片自动识别进出托盘数量</p>
                </li>
                <li>
                    <div><img src="~assets/image/solution-img/smart5.png" alt=""></div>
                    <p>数据展示：将借出和归还托盘数据，在前置仓专用屏展示，一目了然。</p>
                </li>
            </ul>
        </div>
        <div class="return">
            <div class="title">归还借出流程</div>
            <div class="wrapper">
                <dl class="returnContent">
                    <dt>归还</dt>
                    <dd v-for="(item,index) in returnContent">{{item.desc}}</dd>
                </dl>
                <dl class="land returnContent">
                    <dt>借出</dt>
                    <dd v-for="(item,index) in land">{{item.desc}}</dd>
                </dl>
            </div>
            <p>高效部署 + 无人值守 + 自租自还 + 自动计账</p>
            <div class="image">
                <img src="~assets/image/solution-img/smartBeforeStore02.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            returnContent: [
                { desc: '1、持授权卡用户送托盘进入前置仓' },
                { desc: '2、识别用户' },
                { desc: '3、识别托盘数量' },
                { desc: '4、归还成功' },
                { desc: '5、自动同步归还记账' },
            ],
            land:[
                {desc:'1、持授权卡用户进入前置仓取出托盘'},
                {desc:'2、识别用户'},
                {desc:'3、识别托盘数量'},
                {desc:'4、租出成功'},
                {desc:'5、自动同步起租数据'}
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin titleStyle {
    width: 100%;
    height: 50px;
    background: #ff6000;
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 24px;
}
.ancestor {
    background: #fff;
    width: 100%;
    margin-top: 30px;
    padding-bottom: 30px;
    .theme-titles {
        height: 55px;
        padding: 10px 30px;
        background: #fff;
        border-bottom: 5px solid #ff6000;
        font-size: 16px;
        .theme-text {
            float: left;
            width: 300px;
            > img {
                width: 39px;
                vertical-align: middle;
            }
            .boult {
                margin-left: 5px;
                font-weight: bold;
                color: #ff6000;
            }
            .theme-name {
                font-weight: bold;
                display: inline-block;
                // margin-top: 6px;
                margin-left: 12px;
            }
        }
    }
    .header {
        margin: 30px;
        > div {
            height: 50px;
            margin: 30;
            p {
                text-indent: 2em;
            }
        }
    }
    .sortware {
        margin: 20px 0 50px 0;
        h3 {
            margin-top: 30px;
            text-indent: 2em;
        }
        .title {
            @include titleStyle;
        }

        .imgs {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 30px;
            img {
                width: 800px;
            }
        }
        ul {
            display: flex;
            margin-top: 20px;
            flex-flow: wrap;
            li {
                width: 380px;
                height: 70px;
                border: 2px solid #ff8800;
                border-radius: 35px;
                margin: 15px 10px;
                display: flex;
                align-items: center;
                div {
                    width: 50px;
                    height: 50px;
                    margin: 0 2px;
                    img {
                        width: 45px;
                    }
                }
                p {
                    width: 310px;
                    font-weight: bold;
                }
            }
        }
    }
    // 归还借出流程
    .return {
        margin-top: 20px;
        .title {
            @include titleStyle;
        }
        .wrapper {
            display: flex;
            justify-content: space-between;
            // &:before,
            // &:after {
            //     content: "";
            //     display: block;
            // }
            .returnContent {
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                dd,
                dt {
                    height: 30px;
                    background: #fb7900;
                    border-radius: 5px;
                    line-height: 30px;
                    color: #fff;
                }
                dt {
                    width: 132px;
                    text-align: center;
                    margin: 20px 0;
                    font-size: 22px;
                }
                dd {
                    width: 340px;
                    padding-left: 10px;
                    margin-top: 20px;
                }
            }
            .land{
                dd,dt{
                    background: #1ca4f9;
                }
            }
        }
        >p{
            font-size: 22px;
            color: #FF8800;
            font-weight: bold;
            margin-top: 40px;
            text-align: center;
        }
        >.image{
            width: 833px;
            margin-top: 40px;
            img{
                width: 100%;
            }
        }
    }
}
</style>